import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search, Mail, Phone } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center px-6 py-12">
      <div className="max-w-4xl w-full">
        <div className="text-center">
          {/* Número 404 grande y estilizado */}
          <div className="mb-8">
            <h1 className="text-[180px] md:text-[250px] font-bold leading-none bg-gradient-to-br from-[#0b742f] via-[#0b742f] to-[#e87729] bg-clip-text text-transparent select-none">
              404
            </h1>
            <div className="flex items-center justify-center gap-2 -mt-8">
              <div className="h-1 w-16 bg-gradient-to-r from-transparent via-[#0b742f] to-transparent rounded-full"></div>
              <div className="h-1 w-24 bg-gradient-to-r from-[#0b742f] to-[#e87729] rounded-full"></div>
              <div className="h-1 w-16 bg-gradient-to-r from-[#e87729] via-[#e87729] to-transparent rounded-full"></div>
            </div>
          </div>

          {/* Mensaje principal */}
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Página no encontrada
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-6">
              Lo sentimos, la página que estás buscando no existe o ha sido movida a otra ubicación.
            </p>
            <p className="text-gray-500">
              Es posible que hayas escrito incorrectamente la dirección o que la página haya sido eliminada.
            </p>
          </div>

          {/* Botones de acción */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-3 bg-white text-[#0b742f] border-2 border-[#0b742f] px-8 py-4 rounded-xl font-bold text-lg hover:bg-[#0b742f] hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              <ArrowLeft className="w-6 h-6" />
              Volver atrás
            </button>

            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-3 bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white px-8 py-4 rounded-xl font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              <Home className="w-6 h-6" />
              Ir al inicio
            </button>
          </div>

          {/* Tarjetas de ayuda */}
          <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white rounded-xl shadow-md p-6 border-t-4 border-[#0b742f] hover:shadow-lg transition-shadow duration-300">
              <div className="bg-[#0b742f]/10 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
                <Search className="w-6 h-6 text-[#0b742f]" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Explorar</h3>
              <p className="text-sm text-gray-600">
                Usa el menú de navegación para encontrar lo que buscas
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 border-t-4 border-[#e87729] hover:shadow-lg transition-shadow duration-300">
              <div className="bg-[#e87729]/10 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-6 h-6 text-[#e87729]" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Contacto</h3>
              <a
                href="mailto:contacto@cenid.org"
                className="text-sm text-[#e87729] hover:underline"
              >
                contacto@cenid.org
              </a>
            </div>

            <div className="bg-white rounded-xl shadow-md p-6 border-t-4 border-blue-600 hover:shadow-lg transition-shadow duration-300">
              <div className="bg-blue-600/10 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Teléfono</h3>
              <a
                href="tel:+523310618187"
                className="text-sm text-blue-600 hover:underline"
              >
                +52 33 1061 8187
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
